// import React from "react";
// import {
//     Box,
//     Typography,
//     Button,
//     Card,
//     CardContent,
//     Avatar,
//     Grid,
//     Divider,
//     Stack,
//     Paper,
//     styled,
//     Container,
//     Table,
//     TableBody,
//     TableRow,
//     TableCell,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { FiUsers } from "react-icons/fi";
// import { IoMdTransgender } from "react-icons/io";
// import { MdOutlineDateRange } from "react-icons/md";
// import { MdOutlineEmail } from "react-icons/md";
// import { IoCallOutline } from "react-icons/io5";
// import { MdOutlineMyLocation } from "react-icons/md";
// import { MdOutlineAddLocation } from "react-icons/md";
// import { MdOutlineLocationOn } from "react-icons/md";
// import { GrMapLocation } from "react-icons/gr";
// import { FaUserGraduate } from "react-icons/fa";
// import { TiLocationArrowOutline } from "react-icons/ti";
// import { MdOutlineBatchPrediction } from "react-icons/md";
// import { SiAndroidstudio } from "react-icons/si";
// import { CgWebsite } from "react-icons/cg";
// import image from "../../../Assets/Media.jpg"
// const ProfileContainer = styled(Box)(({ theme }) => ({
//     backgroundColor: "#f5f5f5",
//     minHeight: "100vh",
//     padding: theme.spacing(2),
// }));


// const ResponsiveBox = styled(Box)(({ theme }) => ({
//     display: "flex",
//     flexDirection: "column",
//     gap: theme.spacing(2),
//     [theme.breakpoints.up("md")]: {
//         flexDirection: "row",
//     },
// }));
// const ProfileDetails = () => {


//     const user = {
//         name: "Khushi Bhargava",
//         gender: "Female",
//         dob: "31/08/2000",
//         email: "sudhir_bhargava@hotmail.com",
//         mobile: "9818171714",
//         permanentCity: "DELHI",
//         yearOfCompletion: "2022",
//         campus: "MUMBAI",
//         batch: "2018-2022",
//         course: "B. Des Textile Design",
//         views: 85,
//         connections: 0,
//         image: image
//     };



//     const userInfoRows = [
//         { label: 'Name', icon: FiUsers, value: user.name },
//         { label: 'Gender', icon: IoMdTransgender, value: user.gender },
//         { label: 'Date of Birth', icon: MdOutlineDateRange, value: user.dob },
//         { label: 'Email', icon: MdOutlineEmail, value: user.email },
//         { label: 'Mobile', icon: IoCallOutline, value: user.mobile },
//         { label: 'Present Address', icon: MdOutlineMyLocation, value: user.presentAddress },

//         { label: 'Present City', icon: MdOutlineAddLocation, value: user.presentCity },
//         { label: 'Permanent Address', icon: MdOutlineLocationOn, value: user.permanentAddress },

//         { label: 'Permanent City', icon: GrMapLocation, value: user.permanentCity },
//         { label: 'Year of Completion', icon: FaUserGraduate, value: user.yearOfCompletion },
//         { label: 'Campus', icon: TiLocationArrowOutline, value: user.campus },
//         { label: 'Batch', icon: MdOutlineBatchPrediction, value: user.batch },
//         { label: 'Course', icon: SiAndroidstudio, value: user.course },
//         { label: 'Website', icon: CgWebsite, value: user.website },
//     ];


//     const experienceData = [
//         {
//             title: "Software Engineer at ABC Corp",
//             duration: "Jan 2023 - Present",
//             description: "Working on full-stack projects using React, Node.js, and GraphQL.",
//         },
//         {
//             title: "Frontend Developer at XYZ Inc",
//             duration: "June 2020 - Dec 2022",
//             description: "Developed and maintained several React applications, improving performance by 20%.",
//         },
//     ];

//     const educationData = [
//         {
//             title: "B.Tech in Computer Science",
//             duration: "Indian Institute of Technology, Delhi (2016 - 2020)",
//             description: "Specialized in software development and algorithm design.",
//         },
//         {
//             title: "Diploma in Web Development",
//             duration: "ABC Institute (2014 - 2016)",
//             description: "Focused on front-end technologies and responsive design.",
//         },
//     ];




//     const skills = ["JavaScript", "React.js", "Node.js", "UI/UX Design", "MongoDB", "Git", "Agile"];

//     const awards = [
//         "🏆 Employee of the Month – Cygnusa (July 2023)",
//         "🏅 Best UI Design – Hackathon 2022",
//         "🎖️ Top Performer – Q1 2024",
//     ];

//     const projects = [
//         {
//             title: "QuizzyPro",
//             description: "A full-stack quiz platform with real-time results and analytics.",
//         },
//         {
//             title: "SmartShop UI Revamp",
//             description: "Redesigned an e-commerce platform's frontend, improving UX by 30%.",
//         },
//         {
//             title: "Cygnusa Admin Dashboard",
//             description: "Developed a responsive dashboard with analytics and user controls.",
//         },
//     ];

//     const groups = [
//         "Frontend Developers – India",
//         "React.js Community",
//         "Cygnusa Tech Circle",
//         "UI/UX Designers Hub",
//     ];


//     // =====================================
//     const SectionCard = ({ title, children }) => (
//         <Card sx={{ mb: 2 }}>
//             <CardContent>
//                 <Typography variant="h6" gutterBottom>
//                     {title}
//                 </Typography>
//                 {children}
//             </CardContent>
//         </Card>
//     );

//     const SkillsSection = ({ skills }) => (
//         <SectionCard title="Skills & Endorsements">
//             <Stack direction="row" spacing={1} flexWrap="wrap">
//                 {skills.map((skill, idx) => (
//                     <Paper
//                         key={idx}
//                         elevation={1}
//                         sx={{ px: 2, py: 0.5, mb: 1, borderRadius: 2 }}
//                     >
//                         <Typography variant="body2">{skill}</Typography>
//                     </Paper>
//                 ))}
//             </Stack>
//         </SectionCard>
//     );


//     const AwardsSection = ({ awards }) => (
//         <SectionCard title="Awards">
//             <ul style={{ paddingLeft: "1rem", margin: 0 }}>
//                 {awards.map((award, idx) => (
//                     <li key={idx}>
//                         <Typography variant="body2">{award}</Typography>
//                     </li>
//                 ))}
//             </ul>
//         </SectionCard>
//     );


//     const ProjectsSection = ({ projects }) => (
//         <SectionCard title="Projects">
//             <Box>
//                 {projects.map((project, idx) => (
//                     <Box key={idx} mb={1}>
//                         <Typography variant="subtitle2">{project.title}</Typography>
//                         <Typography
//                             variant="body2"
//                             gutterBottom
//                             color="text.secondary"
//                         >
//                             {project.description}
//                         </Typography>
//                     </Box>
//                 ))}
//             </Box>
//         </SectionCard>
//     );


//     const GroupsSection = ({ groups }) => (
//         <SectionCard title="Groups">
//             <Stack spacing={1}>
//                 {groups.map((group, idx) => (
//                     <Typography key={idx} variant="body2">
//                         👥 {group}
//                     </Typography>
//                 ))}
//             </Stack>
//         </SectionCard>
//     );



//     const InfoTable = ({ rows }) => (
//         <Table>
//             <TableBody>
//                 {rows.map(({ label, value, icon: Icon }, index) => (
//                     <TableRow key={index}>
//                         <TableCell sx={{ width: '30%' }}>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <Icon style={{ marginRight: "5px" }} />
//                                 <Typography variant="body2">{label}</Typography>
//                             </Box>
//                         </TableCell>
//                         <TableCell>
//                             <Typography variant="subtitle1">{value || '-'}</Typography>
//                         </TableCell>
//                     </TableRow>
//                 ))}
//             </TableBody>
//         </Table>
//     );

//     // const InfoRow = ({ label, value }) => (
//     //     <Stack direction="row" justifyContent="space-between" py={1}>
//     //         <Typography variant="subtitle2" fontWeight="bold">{label}</Typography>
//     //         <Typography>{value || "-"}</Typography>
//     //     </Stack>
//     // );



//     const EmptyBox = ({ title, message }) => (
//         <Card sx={{ mb: 2 }}>
//             <CardContent>
//                 <Typography fontWeight="bold">{title}</Typography>
//                 <Typography color="error">{message}</Typography>
//             </CardContent>
//         </Card>
//     );

//     return (
//         <Box
//             data-aos="zoom-in" data-aos-duration="1000"
//             sx={{
//                 position: 'relative',
//             }}>

//             <Box sx={{ px: 8, py: 4 }}>
//                 <Button
//                     variant="contained"
//                     startIcon={<ArrowBackIcon />}
//                     sx={{ mb: 2, backgroundColor: "#d9534f", "&:hover": { backgroundColor: "#c9302c" } }}
//                 >
//                     Go back
//                 </Button>

//                 <Grid container spacing={2}>
//                     {/* Left Sidebar */}
//                     <Grid item size={{ xs: 12, md: 4 }} >
//                         <Card sx={{ textAlign: "center", mb: 2 }}>
//                             <CardContent>
//                                 <Avatar
//                                     src={user.image}
//                                     sx={{
//                                         width: 250, height: 250, margin: "0 auto", mb: 2, objectFit: "contian",
//                                         border: "1px solid #ccc",
//                                         "& .MuiAvatar-img": {
//                                             objectFit: "contain"
//                                         }

//                                     }}
//                                 />
//                                 <Typography variant="h6">{user.name}</Typography>
//                                 <Stack direction="row" justifyContent="space-around" mt={2}>
//                                     <Box>
//                                         <Typography variant="body2">{user.connections}</Typography>
//                                         <Typography variant="caption">Connections</Typography>
//                                     </Box>
//                                     <Box>
//                                         <Typography variant="body2">{user.views}</Typography>
//                                         <Typography variant="caption">Views</Typography>
//                                     </Box>
//                                 </Stack>
//                             </CardContent>
//                         </Card>

//                         {/* Sidebar Widgets */}
//                         {/* <EmptyBox title="Skills & Endorsements" message="Skill details not available!" /> */}

//                         {/* Skills & Endorsements */}
//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Skills & Endorsements
//                                 </Typography>
//                                 <Stack direction="row" spacing={1} flexWrap="wrap">
//                                     {[
//                                         "JavaScript",
//                                         "React.js",
//                                         "Node.js",
//                                         "UI/UX Design",
//                                         "MongoDB",
//                                         "Git",
//                                         "Agile",
//                                     ].map((skill, idx) => (
//                                         <Paper
//                                             key={idx}
//                                             elevation={1}
//                                             sx={{ px: 2, py: 0.5, mb: 1, borderRadius: 2 }}
//                                         >
//                                             <Typography variant="body2">{skill}</Typography>
//                                         </Paper>
//                                     ))}
//                                 </Stack>
//                             </CardContent>
//                         </Card>


//                         {/* Awards */}
//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Awards
//                                 </Typography>
//                                 <ul style={{ paddingLeft: "1rem", margin: 0 }}>
//                                     <li>
//                                         <Typography variant="body2">
//                                             🏆 Employee of the Month – Cygnusa (July 2023)
//                                         </Typography>
//                                     </li>
//                                     <li>
//                                         <Typography variant="body2">
//                                             🏅 Best UI Design – Hackathon 2022
//                                         </Typography>
//                                     </li>
//                                     <li>
//                                         <Typography variant="body2">
//                                             🎖️ Top Performer – Q1 2024
//                                         </Typography>
//                                     </li>
//                                 </ul>
//                             </CardContent>
//                         </Card>

//                         {/* <EmptyBox title="Awards" message="Award details not available!" /> */}

//                         {/* Projects */}
//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Projects
//                                 </Typography>
//                                 <Box>
//                                     <Typography variant="subtitle2">QuizzyPro</Typography>
//                                     <Typography
//                                         variant="body2"
//                                         gutterBottom
//                                         color="text.secondary"
//                                     >
//                                         A full-stack quiz platform with real-time results and analytics.
//                                     </Typography>

//                                     <Typography variant="subtitle2">SmartShop UI Revamp</Typography>
//                                     <Typography
//                                         variant="body2"
//                                         gutterBottom
//                                         color="text.secondary"
//                                     >
//                                         Redesigned an e-commerce platform's frontend, improving UX by 30%.
//                                     </Typography>

//                                     <Typography variant="subtitle2">Cygnusa Admin Dashboard</Typography>
//                                     <Typography
//                                         variant="body2"
//                                         gutterBottom
//                                         color="text.secondary"
//                                     >
//                                         Developed a responsive dashboard with analytics and user controls.
//                                     </Typography>
//                                 </Box>
//                             </CardContent>
//                         </Card>

//                         {/* <EmptyBox title="Projects" message="Project details not available!" /> */}
//                         {/* <EmptyBox title="Groups" message="Group details not available!" />
//                     </Grid> */}
//                         {/* Groups */}
//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Groups
//                                 </Typography>
//                                 <Stack spacing={1}>
//                                     {[
//                                         "Frontend Developers – India",
//                                         "React.js Community",
//                                         "Cygnusa Tech Circle",
//                                         "UI/UX Designers Hub",
//                                     ].map((group, idx) => (
//                                         <Typography key={idx} variant="body2">
//                                             👥 {group}
//                                         </Typography>
//                                     ))}
//                                 </Stack>
//                             </CardContent>
//                         </Card>
//                     </Grid>


//                     {/* Main Profile Info */}
//                     <Grid item size={{ xs: 12, md: 8 }}>
//                         <Card>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Personal Details
//                                 </Typography>
//                                 {/* <Divider sx={{ mb: 2 }} />
//                                 <InfoRow label="First Name" value={user.name} />
//                                 <InfoRow label="Gender" value={user.gender} />
//                                 <InfoRow label="Date Of Birth" value={user.dob} />
//                                 <InfoRow label="E-mail" value={user.email} />
//                                 <InfoRow label="Mobile No" value={user.mobile} />
//                                 <InfoRow label="Present Address" value="" />
//                                 <InfoRow label="Present City" value="" />
//                                 <InfoRow label="Permanent Address" value="" />
//                                 <InfoRow label="Permanent City" value={user.permanentCity} />
//                                 <InfoRow label="Year Of Completion" value={user.yearOfCompletion} />
//                                 <InfoRow label="Campus" value={user.campus} />
//                                 <InfoRow label="Batch" value={user.batch} />
//                                 <InfoRow label="Course" value={user.course} />
//                                 <InfoRow label="Website" value="" /> */}
//                                 <InfoTable rows={userInfoRows} />

//                             </CardContent>
//                         </Card>

//                         {/* Experience + Education */}
//                         {/* <EmptyBox title="Experience" message="Experience details not available!" />
//                         <EmptyBox title="Education" message="Educational details not available!" />
//                      */}

//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Experience
//                                 </Typography>
//                                 <Box>
//                                     {experienceData.map((item, index) => (
//                                         <Box key={index} mb={1.5}>
//                                             <Typography variant="subtitle2">{item.title}</Typography>
//                                             <Typography variant="body2" color="text.secondary">
//                                                 {item.duration}
//                                             </Typography>
//                                             <Typography variant="body2" gutterBottom>
//                                                 {item.description}
//                                             </Typography>
//                                         </Box>
//                                     ))}
//                                 </Box>
//                             </CardContent>
//                         </Card>

//                         <Card sx={{ mb: 2 }}>
//                             <CardContent>
//                                 <Typography variant="h6" gutterBottom>
//                                     Education
//                                 </Typography>
//                                 <Box>
//                                     {educationData.map((item, index) => (
//                                         <Box key={index} mb={1.5}>
//                                             <Typography variant="subtitle2">{item.title}</Typography>
//                                             <Typography variant="body2" color="text.secondary">
//                                                 {item.duration}
//                                             </Typography>
//                                             <Typography variant="body2">{item.description}</Typography>
//                                         </Box>
//                                     ))}
//                                 </Box>
//                             </CardContent>
//                         </Card>

//                     </Grid>
//                 </Grid>
//             </Box >

//         </Box >

//     );
// };

// export default ProfileDetails;



import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Avatar,
    Grid,
    Divider,
    Stack,
    Paper,
    styled,
    Container,
    Table,
    TableBody,
    TableRow,
    TableCell,
    duration,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FiUsers } from "react-icons/fi";
import { IoMdTransgender } from "react-icons/io";
import { MdOutlineDateRange } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import { MdOutlineMyLocation } from "react-icons/md";
import { MdOutlineAddLocation } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { GrMapLocation } from "react-icons/gr";
import { FaUserGraduate } from "react-icons/fa";
import { TiLocationArrowOutline } from "react-icons/ti";
import { MdOutlineBatchPrediction } from "react-icons/md";
import { SiAndroidstudio } from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import image from "../../../../Assets/Media.jpg"
import { useNavigate, useParams } from "react-router-dom";
import actions from "../../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import { adminUrl } from "../../../../constants";
const ProfileContainer = styled(Box)(({ theme }) => ({
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    padding: theme.spacing(2),
}));


const ResponsiveBox = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
    },
}));
const ProfileDetails = () => {
    const { userId } = useParams();

    const dispatch = useDispatch()


    // const { RegistrationProfileGetById } = useSelector(
    //     (state) => state?.RegistrationProfileGetById
    // );
    // const { AlumniSkillsGetById } = useSelector(
    //     (state) => state?.AlumniSkillsGetById
    // );
    // const { AlumniAwardGetById } = useSelector(
    //     (state) => state?.AlumniAwardGetById
    // );
    // const { AlumniEducationGetById } = useSelector(
    //     (state) => state?.AlumniEducationGetById
    // );
    // const { AlumniExperienceGetById } = useSelector(
    //     (state) => state?.AlumniExperienceGetById
    // );
    // const { AlumniProjectGetById } = useSelector(
    //     (state) => state?.AlumniProjectGetById
    // );

    // useEffect(() => {
    //     const fetchData = async () => {

    //         const data1 = {
    //             data: {},
    //             method: "put",
    //             apiName: `aluminiprofileedit/${userId}`,
    //         };

    //         const responseData = await dispatch(actions.REGISTRATIONPROFILEGETBYID(data1));
    //         console.log(responseData, "responseDataaa")

    //         const data2 = {
    //             data: {},
    //             method: "get",
    //             apiName: `aluminiskills/${userId}`,
    //         };

    //         const responseDataSkills = await dispatch(actions.ALUMNISKILLSGETBYID(data2));
    //         console.log(responseDataSkills, "responseDataaa")

    //         const data3 = {
    //             data: {},
    //             method: "get",
    //             apiName: `aluminiawards/${userId}`,
    //         };

    //         const responseDataAwards = await dispatch(actions.ALUMNIAWARDSGETBYID(data3));
    //         console.log(responseDataAwards, "responseDataaa")

    //         const data4 = {
    //             data: {},
    //             method: "get",
    //             apiName: `aluminiprojects/${userId}`,
    //         };

    //         const responseDataProjects = await dispatch(actions.ALUMNIPROJECTSGETBYID(data4));
    //         console.log(responseDataProjects, "responseDataaa")

    //         const data5 = {
    //             data: {},
    //             method: "get",
    //             apiName: `aluminiexperiences/${userId}`,
    //         };

    //         const responseDataExperience = await dispatch(actions.ALUMNIEXPERIENCEGETBYID(data5));
    //         console.log(responseDataExperience, "responseDataaa")

    //         const data6 = {
    //             data: {},
    //             method: "get",
    //             apiName: `aluminieducation/${userId}`,
    //         };

    //         const responseDataEducation = await dispatch(actions.ALUMNEDUCATIONGETBYID(data6));
    //         console.log(responseDataEducation, "responseDataaa")
    //         // setResponseTableData(responseData?.payload)
    //     }


    //     fetchData();

    // }, []);


    // Skills
    const [skillsData, setSkillsData] = useState([])

    console.log(skillsData, "skillsData")
    // const { updateUserStoreInfo } = useSelector(state => state?.updateUserStoreInfo);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserSkills/${userId}`,
            };
            const response = await dispatch(actions.GETUSERSKILLS(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "getUserSkills fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                // const responseData = response?.payload?.data?.map((data) => ({
                //     // user_id: data?.user_id,

                //      data,






                // }))
                setSkillsData(response?.payload?.data)

            }
        }
        fetchData()


    }, [])



    const { ProfileviewDetailsByUserId } = useSelector(state => state?.ProfileviewDetailsByUserId);


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserById/${userId}`,
            };
            const response = await dispatch(actions.PROFILEVIEWDETAILBYUSERID(data1));

            console.log(response, "responseresponse")


        }
        fetchData()


    }, [])

    // Awards    
    const [awardData, setAwardData] = useState([])
    console.log(awardData, "awardata")
    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getAwardsByUserId/${userId}`,
            };
            const response = await dispatch(actions.GETAWARDSBYUSRID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Awards fetched successfully") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.award_id,
                    award_name: data?.award_name,
                    certificate_file: data?.certificate_file,
                    description: data?.description,
                    issued_by: data?.issued_by,
                    feild: data?.title,
                    award_date: data?.award_date



                }))
                setAwardData(responseData)

            }
        }
        fetchData()


    }, [])

    // const [educationData, setEducationData] = useState([])
    const [projectData, setProjectData] = useState([])
    console.log(projectData, "projectData")
    // projects

    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getProjectsByUserId/user/${userId}`,
            };
            const response = await dispatch(actions.GETPROJECTSBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Projects fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.project_id,
                    project_title: data?.project_title,
                    role: data?.role,
                    description: data?.description,
                    start_date: data?.start_date,
                    end_date: data?.end_date,
                    skills: data?.skills,






                }))
                setProjectData(responseData)

            }
        }
        fetchData()


    }, [])


    // experience
    const [experienceData, setExperienceData] = useState([])


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getExperiencesByUserId/${userId}`,
            };
            const response = await dispatch(actions.GETEXPERIENCEBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Experiences fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.experience_id,
                    job_title: data?.job_title,
                    company_name: data?.company_name,
                    employment_type: data?.employment_type,
                    start_date: data?.start_date,
                    end_date: data?.end_date,
                    location: data?.location,
                    skills_used: data?.skills_used,
                    description: data?.description,
                    industry_category: data?.industry_category,






                }))
                setExperienceData(responseData)

            }
        }
        fetchData()


    }, [])

    // Education
    const [educationData, setEducationData] = useState([])


    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `usergetEducationsByUserId/${userId}`,
            };
            const response = await dispatch(actions.USERGETEDUCATIONSBYUSERID(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "Educations fetched for user.") {
                console.log("hiiiiiiiiiiiiiiii")

                const responseData = response?.payload?.data?.map((data) => ({
                    // user_id: data?.user_id,
                    id: data?.education_id,
                    institute_name: data?.institute_name,
                    degree: data?.degree,
                    field_of_study: data?.field_of_study,
                    start_date: data?.start_date,
                    end_date: data?.end_date,
                    grade: data?.grade,
                    extra_curricular: data?.extra_curricular,
                    description: data?.description,




                }))
                setEducationData(responseData)

            }
        }
        fetchData()


    }, [])








    const userInfoRows = [
        { label: 'Name', icon: FiUsers, value: `${ProfileviewDetailsByUserId?.data?.first_name} ${ProfileviewDetailsByUserId?.data?.last_name}` },
        { label: 'Gender', icon: IoMdTransgender, value: ProfileviewDetailsByUserId?.data?.gender },
        { label: 'Date of Birth', icon: MdOutlineDateRange, value: ProfileviewDetailsByUserId?.data?.date_of_birth },
        { label: 'Personal Email', icon: MdOutlineEmail, value: ProfileviewDetailsByUserId?.data?.personal_email },
        { label: 'Official Email', icon: MdOutlineEmail, value: ProfileviewDetailsByUserId?.data?.official_email },

        { label: 'Mobile', icon: IoCallOutline, value: ProfileviewDetailsByUserId?.data?.phone_no },
        { label: 'Present Address', icon: MdOutlineMyLocation, value: ProfileviewDetailsByUserId?.data?.present_address },

        { label: 'Present City', icon: MdOutlineAddLocation, value: ProfileviewDetailsByUserId?.data?.present_city },
        { label: 'Present State', icon: MdOutlineAddLocation, value: ProfileviewDetailsByUserId?.data?.present_state },
        { label: 'Present Country', icon: MdOutlineAddLocation, value: ProfileviewDetailsByUserId?.data?.present_country } || "--",

        { label: 'Permanent Address', icon: MdOutlineLocationOn, value: ProfileviewDetailsByUserId?.data?.permanentAddress },

        { label: 'Permanent City', icon: GrMapLocation, value: ProfileviewDetailsByUserId?.data?.permanentCity },
        { label: 'Year of Completion', icon: FaUserGraduate, value: ProfileviewDetailsByUserId?.data?.Year_of_completion },
        { label: 'Campus', icon: TiLocationArrowOutline, value: ProfileviewDetailsByUserId?.data?.campus },
        { label: 'Batch', icon: MdOutlineBatchPrediction, value: ProfileviewDetailsByUserId?.data?.batch },
        { label: 'Course', icon: SiAndroidstudio, value: ProfileviewDetailsByUserId?.data?.course },
        { label: 'Website', icon: CgWebsite, value: ProfileviewDetailsByUserId?.data?.website_url },
    ];








    const groups = [
        "Frontend Developers – India",
        "React.js Community",
        "Cygnusa Tech Circle",
        "UI/UX Designers Hub",
    ];


    // =====================================
    const SectionCard = ({ title, children }) => (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <Divider sx={{ marginBottom: 2 }} />

                {children}
            </CardContent>
        </Card>
    );


    // skills

    const SkillsSection = ({ skillsData }) => (
        <SectionCard title="Skills & Endorsements">
            <Stack direction="row" spacing={1} flexWrap="wrap">
                <Box
                    sx={{
                        display: "flex",
                        // justifyContent: "space-between", // or "flex-start" if you want them to align without extra spacing
                        flexWrap: "wrap", // optional, if you want them to wrap on smaller screens
                        gap: 2, // optional, for consistent spacing between items
                        mt: 2,
                    }}
                >
                    {skillsData?.length > 0 ? (

                        skillsData.map((skill, idx) => (
                            <Paper
                                key={idx}
                                elevation={1}
                                sx={{ px: 2, py: 0.5, borderRadius: 2, background: "#ccc" }}
                            >
                                <Typography variant="subtitle1">{skill}</Typography>
                            </Paper>
                        ))

                    ) : (
                        // <Typography variant="error">no skills available</Typography>
                        <Typography color="error">Skill details not availabe!</Typography>


                    )}
                </Box>
            </Stack>
        </SectionCard>
    );


    // const AwardsSection = ({ awards }) => (
    //     <SectionCard title="Awards">
    //         <ul style={{ paddingLeft: "1rem", margin: 0 }}>
    //             {awards?.length > 0 ? (

    //                 awards.map((award, idx) => (
    //                     <li key={idx} style={{ marginBottom: "10px" }}>
    //                         <Typography variant="body2">{award?.title}-{award?.organization} ({award?.year})</Typography>
    //                         <Typography variant="body1">{award?.remarks}</Typography>

    //                     </li>
    //                 ))
    //             ) : (
    //                 <Typography color="error">Award details not availabe!
    //                 </Typography>

    //             )}
    //         </ul>
    //     </SectionCard>
    // );


    const AwardsSection = ({ awards }) => (
        <SectionCard title="Awards">
            <ul style={{ paddingLeft: "1rem", margin: 0 }}>
                {awards?.length > 0 ? (



                    awards.map((award, idx) => (
                        <li key={idx} style={{ marginBottom: "10px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="h6" sx={{ fontSize: "16px" }}>{award?.award_name}</Typography>

                            </Box>
                            <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>@{award?.issued_by} - <span style={{ fontSize: "12px", color: "gray" }}>{award?.award_date}</span></Typography>


                            <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{award?.feild}</Typography>
                            {/* <Typography variant="body1" sx={{ fontSize: "12px" }}>{award?.award_date}</Typography> */}


                            <Typography variant="body1">{award?.description}</Typography>


                        </li>
                    ))
                ) : (
                    <Typography color="error">Award details not availabe!
                    </Typography>

                )}
            </ul>
        </SectionCard>
    );




    const ProjectsSection = ({ projectData }) => (
        <SectionCard title="Projects" >
            <ul style={{ paddingLeft: "1rem", margin: 0 }}>

                {projectData?.length > 0 ? (
                    projectData.map((project, idx) => (
                        <li key={idx} mb={1}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography variant="body2">{project?.project_title}</Typography>

                            </Box>
                            <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{project?.role}</Typography>

                            <Typography variant="body1" fontSize="14px">{project?.start_date} to {project?.end_date}</Typography>
                            <Typography variant="body1">
                                Skills used: {project?.skills?.join(' , ')}
                            </Typography>
                            <Typography
                                variant="body1"

                            >
                                {project?.description}
                            </Typography>
                        </li>
                    ))
                ) : (
                    <Typography color="error">Project details not availabe!</Typography>

                )}
            </ul>
        </SectionCard>
    );


    const EducationSection = ({ educationData }) => (
        <SectionCard title="Education">
            <ul style={{ paddingLeft: "1rem", margin: 0 }}>
                {
                    educationData?.length ? (
                        educationData.map((data, idx) => (
                            <li key={idx} style={{ marginBottom: "10px" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="h6" sx={{ fontSize: "16px" }}>{data?.institute_name}</Typography>

                                </Box>
                                <Box key={idx} mb={1.5}>
                                    <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{data?.degree} {data?.field_of_study}</Typography>
                                    <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{data?.grade} CGPA</Typography>

                                    <Typography variant="body1"
                                    // fontSize="14px" 
                                    >
                                        {data?.start_date} to {data?.end_date}
                                    </Typography>
                                    <Typography variant="body1">{data?.description}</Typography>
                                </Box>
                            </li>

                        ))
                    ) : (
                        <Typography color="error">Education details not availabe!
                        </Typography>

                    )
                }
            </ul>
        </SectionCard>
    )




    const GroupsSection = ({ groups }) => (
        <SectionCard title="Groups">
            <Stack spacing={1}>
                {groups?.length > 0 ? (
                    groups.map((group, idx) => (
                        <Typography key={idx} variant="subtirle1">
                            👥 {group}
                        </Typography>
                    ))
                ) : (
                    <Typography color="error">Group details not availabe!
                    </Typography>

                )}
            </Stack>
        </SectionCard>
    );



    const ExperienceSection = ({ experienceData }) => (
        <SectionCard title="Experience">
            <ul style={{ paddingLeft: "1rem", margin: 0 }}>
                {
                    experienceData?.length ? (
                        experienceData.map((data, idx) => (
                            <li key={idx} style={{ marginBottom: "10px" }}>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="h6" sx={{ fontSize: "16px" }}>{data?.job_title}</Typography>

                                </Box>
                                <Box key={idx} mb={1.5}>
                                    <Typography variant="subtitle1" sx={{ fontSize: "15px" }}>{data?.company_name} - {data?.location}</Typography>
                                    <Typography variant="subtitle1" sx={{ fontSize: "14px" }}>{data?.employment_type}</Typography>

                                    <Typography variant="body1"
                                    // fontSize="14px" 
                                    >
                                        {data?.start_date} to {data?.end_date}
                                    </Typography>
                                    <Typography variant="body1">
                                        Skills used: {data?.skills_used?.join(' , ')}
                                    </Typography>

                                    <Typography variant="body1">{data?.description}</Typography>
                                </Box>
                            </li>

                        ))
                    ) : (
                        <Typography color="error">Experience details not availabe!
                        </Typography>

                    )
                }
            </ul>
        </SectionCard>
    )




    const InfoTable = ({ rows }) => (
        <Table>
            <TableBody>
                {rows?.map(({ label, value, icon: Icon }, index) => (
                    <TableRow key={index}>
                        <TableCell sx={{ width: '30%' }}>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <Icon style={{ marginRight: "5px" }} />
                                <Typography variant="body2">{label}</Typography>
                            </Box>
                        </TableCell>
                        <TableCell>
                            <Typography variant="subtitle1">{value || '-'}</Typography>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );

    // const InfoRow = ({ label, value }) => (
    //     <Stack direction="row" justifyContent="space-between" py={1}>
    //         <Typography variant="subtitle2" fontWeight="bold">{label}</Typography>
    //         <Typography>{value || "-"}</Typography>
    //     </Stack>
    // );



    const EmptyBox = ({ title, message }) => (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Typography fontWeight="bold">{title}</Typography>
                <Typography color="error">{message}</Typography>
            </CardContent>
        </Card>
    );

    const navigate = useNavigate()

    const { getUserStatsCountByUserId } = useSelector(
        (state) => state?.getUserStatsCountByUserId
    );

    console.log(getUserStatsCountByUserId, "getUserStatsCountByUserIdgetUserStatsCountByUserId")
    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserStatsCount/${userId}`,
            };
            const response = await dispatch(actions.GETUSERSTATUSCOUNTBYUSERID(data1));

        }
        fetchData()
    }, [])


    return (
        <Box
            data-aos="zoom-in" data-aos-duration="1000"
            sx={{
                position: 'relative',
            }}>

            <Box sx={{ px: { md: 8, xs: 3 }, py: 4 }}>
                <Button
                    onClick={() => { navigate(-1) }}
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    sx={{ mb: 2, backgroundColor: "var(--main-color)", "&:hover": { backgroundColor: "var(--main-color)" } }}
                >
                    Go back
                </Button>

                <Grid container spacing={2}>
                    {/* Left Sidebar */}
                    <Grid item size={{ xs: 12, md: 4 }} >
                        <Card sx={{ textAlign: "center", mb: 2 }}>
                            <CardContent>
                                <Avatar
                                    src={`${adminUrl}${ProfileviewDetailsByUserId?.data?.profileImage}`}
                                    sx={{
                                        width: 250, height: 250, margin: "0 auto", mb: 2, objectFit: "contian",
                                        border: "1px solid #ccc",
                                        "& .MuiAvatar-img": {
                                            objectFit: "contain"
                                        }

                                    }}
                                />
                                <Typography variant="h6">{ProfileviewDetailsByUserId?.data?.first_name} {ProfileviewDetailsByUserId?.data?.last_name}</Typography>
                                <Stack direction="row" justifyContent="space-around" mt={2}>
                                    <Box>
                                        <Typography variant="body2">
                                            {getUserStatsCountByUserId?.data?.connectionCount || 0}
                                        </Typography>
                                        <Typography variant="caption">Connections</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body2">
                                            {getUserStatsCountByUserId?.data?.postCount || 0}
                                        </Typography>
                                        <Typography variant="caption">Posts</Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                        <SkillsSection skillsData={skillsData} />
                        {/* {skills?.length > 0 && <SkillsSection skills={skills} />} */}
                        {/* {awards?.length > 0 &&  */}
                        <AwardsSection awards={awardData} />
                        {/* } */}
                        {/* {projects?.length > 0 &&  */}
                        <ProjectsSection projectData={projectData} />
                        {/* } */}

                    </Grid>


                    {/* Main Profile Info */}
                    <Grid item size={{ xs: 12, md: 8 }}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Personal Details
                                </Typography>

                                <InfoTable rows={userInfoRows} />

                            </CardContent>
                        </Card>

                        {/* Experience + Education */}
                        {/* <EmptyBox title="Experience" message="Experience details not available!" />
                        <EmptyBox title="Education" message="Educational details not available!" />
                     */}
                        {/* 
                        <Card sx={{ mb: 2, mt: 2 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Experience
                                </Typography>
                                <Divider sx={{ marginBottom: 2 }} />

                                <Box>
                                    {experienceData?.length ? (
                                        experienceData.map((item, index) => (
                                            <Box key={index} mb={1.5}>
                                                <Typography variant="body2">{item.title}</Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {item.duration}
                                                </Typography>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {item.description}
                                                </Typography>
                                            </Box>
                                        ))
                                    ) : (
                                        <Typography color="error">Group details not availabe!
                                        </Typography>

                                    )}
                                </Box>
                            </CardContent>
                        </Card> */}
                        <Grid sx={{ mb: 2, mt: 2 }}>
                            <ExperienceSection experienceData={experienceData} />
                        </Grid>
                        <Grid sx={{ mb: 2, mt: 2 }}>

                            <EducationSection educationData={educationData} />
                        </Grid>

                    </Grid>
                </Grid>
            </Box >

        </Box >

    );
};

export default ProfileDetails;
